import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Input from '../UI/input/Input';
import cl from './AuthInput.module.css';
import EyeIcon from '../../assets/icons/EyeIcon';
import EyeIconSlash from '../../assets/icons/EyeIconSlash';
import { formatLoginValue, isLoginValid } from './loginHelpers';

const AuthInput = ({ text, validationKey, errorMessage = 'Пожалуйста, введите логин', credentialsError, onValidationComplete, onLoginChange, onPasswordChange, ...inputProps }) => {
  const isPassword = inputProps.type === 'password';

  const [showPassword, setShowPassword] = useState(false);

  const [loginValue, setLoginValue] = useState('');
  const [loginError, setLoginError] = useState(false);

  const [passwordValue, setPasswordValue] = useState('');
  const [passwordError, setPasswordError] = useState(false);

  const inputType = isPassword && showPassword ? 'text' : inputProps.type;

  const handleLoginChange = (event) => {
    const raw = event.target.value;
    const { value, isEmailCandidate } = formatLoginValue(raw);

    setLoginValue(value);
    onLoginChange?.();

    if (isEmailCandidate && value.trim()) {
      setLoginError(false);
    }
  };

  const handlePasswordChange = (event) => {
    const value = event.target.value;
    setPasswordValue(value);
    onPasswordChange?.();
    if (value.trim()) {
      setPasswordError(false);
    }
  };

  useEffect(() => {
    if (!validationKey) return;

    if (isPassword) {
      const valid = !!passwordValue.trim();
      setPasswordError(!valid);
      onValidationComplete?.(valid, passwordValue);
    } else {
      const valid = isLoginValid(loginValue);
      setLoginError(!valid);
      onValidationComplete?.(valid, loginValue);
    }
  }, [validationKey, isPassword]);

  return (
    <div className={cl.authInput}>
      <div className={cl.labelRow}>
        <span className={cl.label}>{text}</span>
        {isPassword && (
          <Link to="/forgot-password" className={cl.forgotPassword}>
            Забыли пароль?
          </Link>
        )}
      </div>

      {isPassword ? (
        <>
          <div className={cl.inputWrapper}>
            <Input
              {...inputProps}
              type={inputType}
              value={passwordValue}
              onChange={handlePasswordChange}
              isError={passwordError}
            />
            {passwordError ? (
              <button
                type="button"
                className={cl.eyeIcon}
                onClick={() => setShowPassword((prev) => !prev)}
                onMouseDown={(e) => e.preventDefault()}
                aria-label="Показать пароль"
              >
                <EyeIconSlash />
              </button>
            ) : (
              <button
                type="button"
                className={cl.eyeIcon}
                onClick={() => setShowPassword((prev) => !prev)}
                onMouseDown={(e) => e.preventDefault()}
                aria-label="Скрыть пароль"
              >
                <EyeIcon />
              </button>
            )}
          </div>
          {passwordError && (
            <span className={cl.errorMessage}>Пожалуйста, введите пароль</span>
          )}
        </>
      ) : (
        <>
          <Input
            {...inputProps}
            value={loginValue}
            onChange={handleLoginChange}
            isError={loginError || !!credentialsError}
          />
          {(loginError || credentialsError) && (
            <span className={cl.errorMessage}>{credentialsError || errorMessage}</span>
          )}
        </>
      )}
    </div>
  )
}

export default AuthInput;